import {setStoreCreditsRemaining, changeExtraItemQuantityAction, changeItemQuantityAction, calculateAllTotals, updateStoreItemAvailability} from "./storeActions";
import {setRecurringItem} from "./recurringOrderActions";
import {fetchingData, dataFetched, errorFetching} from "../common/fetchingActions";
import {FetchingTypes} from "../../common/constants";

export function changeItemQuantity(item, newQuantity, oldQuantity, creditData, updateSchedule) {
    return function (dispatch, getState) {
        const state = getState();
        if(newQuantity === -1) {
            newQuantity = 0;
        }
        if (state.staticData.updateItemAvailabilityOnItemQuantityChange) {
            dispatch(fetchingData(FetchingTypes.UPDATE_ITEM_AVAILABILITY));
            dispatch(updateStoreItemAvailability(state.staticData, item.key, newQuantity, oldQuantity,
                (available) => {
                    if (available < 0) {
                        dispatch(errorFetching({message: `${item.title} cannot be added as it has sold out.`}, undefined, true));
                    } else {
                        dispatch(doChangeItemQuantity(item, newQuantity, oldQuantity, creditData, updateSchedule))
                        dispatch(dataFetched())
                    }
                }));
        }
        else {
            dispatch(doChangeItemQuantity(item, newQuantity, oldQuantity, creditData, updateSchedule))
        }
    }
}

function doChangeItemQuantity(item, newQuantity, oldQuantity, creditData, updateSchedule) {
    return function (dispatch, getState) {
        const state = getState();
        const schedule = item.schedule;
        let changeRecurringQuantity = true;
        if(newQuantity === -1) {
            changeRecurringQuantity = false;
            newQuantity = 0;
        }
        if (creditData && item.isCredit) {
            let qty = item.price*(newQuantity - oldQuantity);
            let remainingCredits = creditData.remainingCredits - (creditData.extraCreditItem?creditData.extraCreditItem.quantity:0) - qty;
            if(creditData.extraCreditItem) {
                dispatch(changeItemQuantityAction(creditData.extraCreditItem.key, remainingCredits < 0 ? -remainingCredits : 0));
                dispatch(changeExtraItemQuantityAction(creditData.extraCreditItem.key, remainingCredits < 0 ? -remainingCredits : 0));
            }
            dispatch(setStoreCreditsRemaining(remainingCredits < 0?0:remainingCredits));
        }
        dispatch(changeItemQuantityAction(item.key, newQuantity));
        if(state.staticData.hasRecurringItems) {
            item.schedule = schedule;
            if(changeRecurringQuantity) {
                item.quantity = newQuantity;
            }
            dispatch(setRecurringItem(item, updateSchedule || state.itemsList.hasOwnProperty(item.key)));
        }
        dispatch(calculateAllTotals());
    }
}


// WEBPACK FOOTER //
// ./src/actions/store/itemCardActions.js